import { createContext, FunctionComponent, ReactNode, useContext } from "react";
import { DevStockEditorBridge } from "./dev-stock-editor-bridge";

export type DevToolsData = {
	stockEditor: DevStockEditorBridge;
};

const DevToolsContext = createContext<DevToolsData | null>(null);

export function useDevTools(): DevToolsData | null {
	return useContext(DevToolsContext);
}

export const DevToolsProvider: FunctionComponent<{
	data: DevToolsData;
	children: ReactNode;
}> = ({ data, children }) => (
	<DevToolsContext.Provider value={data}>{children}</DevToolsContext.Provider>
);
